export const auth0Config = {
  domain: 'auth.payinthi.com',
  clientId: 'RQW3ZtxklsWGmFxJrUsrm99JD2oByVP2',
  redirectUri: window.location.origin,
  // Keep audience optional. Setting this to Auth0 Management API causes
  // "Service not found" unless a matching custom API is configured.
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || undefined,
  scope: 'openid profile email'
};

// Allowed email addresses
export const ALLOWED_EMAILS = [
  'Cody.Manning537@schools.sa.edu.au',
  'Carl.Schilling680@schools.sa.edu.au',
  'Fraser.Mcclements975@schools.sa.edu.au'
];

export const isEmailAllowed = (email: string): boolean => {
  return ALLOWED_EMAILS.some(allowedEmail => 
    allowedEmail.toLowerCase() === email.toLowerCase()
  );
};
